// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Action } from '@ngrx/store';
import { Policy, PolicyDetail, PolicyDetailResponse } from '../../../core/models/index';

export enum PolicyDetailsActionTypes {
  SELECT_POLICY = '[Policy Details] SELECT_POLICY',
  POLICY_DETAILS_LOADING = '[Policy Details] POLICY_DETAILS_LOADING',
  POLICY_DETAILS_LOAD_COMPLETE = '[Policy Details] POLICY_DETAILS_LOAD_COMPLETE',
  POLICY_DETAILS_LOAD_FAILED = '[Policy Details] POLICY_DETAILS_LOAD_FAILED',
}

export class SelectPolicyAction implements Action {
    readonly type = PolicyDetailsActionTypes.SELECT_POLICY;
    constructor(public payload: Policy) {}
}

export class LoadingPolicyDetailsAction implements Action {
    readonly type = PolicyDetailsActionTypes.POLICY_DETAILS_LOADING;
    constructor(public payload: string) {}
}

export class CompleteLoadPolicyDetailsAction implements Action {
    readonly type = PolicyDetailsActionTypes.POLICY_DETAILS_LOAD_COMPLETE;
    constructor(public payload: PolicyDetailResponse) {}
  }
  export class FailLoadPolicyDetailsAction implements Action {
    readonly type = PolicyDetailsActionTypes.POLICY_DETAILS_LOAD_FAILED;
    constructor(public payload: string) {}
  }


export type PolicyDetailsActions =
      SelectPolicyAction
      | LoadingPolicyDetailsAction
      | CompleteLoadPolicyDetailsAction
      | FailLoadPolicyDetailsAction;




// WEBPACK FOOTER //
// ./src/app/access-management/state/policy-details/policy-details.actions.ts